import { Link } from "react-router-dom";
import { Target, ArrowRight } from "lucide-react";
import { BRACHY } from "@/lib/site";

export const Brachytherapy = () => {
  return (
    <section
      data-testid="brachytherapy-section"
      aria-labelledby="brachy-heading"
      className="py-20 md:py-28 bg-blue-950 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-0 right-0 h-96 w-96 rounded-full bg-blue-500 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-96 w-96 rounded-full bg-sky-400 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-300">
              Brachytherapy Expertise
            </div>
            <h2
              id="brachy-heading"
              className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-white"
            >
              Focused radiation, delivered close to the tumour.
            </h2>
            <p className="mt-5 text-blue-100/80 leading-relaxed">{BRACHY.intro}</p>
            <p className="mt-4 text-blue-100/70 leading-relaxed">
              {BRACHY.detail}
            </p>

            <Link
              to="/contact"
              data-testid="brachy-cta"
              className="mt-8 inline-flex items-center gap-2 bg-white text-blue-950 font-semibold px-6 py-3.5 rounded-full hover:bg-blue-50 transition-colors"
            >
              Know More About Treatment Options
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {BRACHY.forms.map((f, i) => (
                <div
                  key={f.title}
                  data-testid={`brachy-form-${i}`}
                  className="rounded-2xl p-6 border border-white/10 bg-white/[0.04] backdrop-blur"
                >
                  <div className="h-10 w-10 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-200">
                    <Target className="h-5 w-5" strokeWidth={1.7} />
                  </div>
                  <h3 className="mt-4 font-serif text-lg text-white">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm text-blue-100/70 leading-relaxed">
                    {f.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brachytherapy;
